import { Location, locationName } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const RiskNotificationsPage = lazy(() => import('@cobliteam/notifications/src/components/RiskNotificationsPage/RiskNotificationsPage'));

const routes = [
  {
    title: locationName[Location.RISK_NOTIFICATIONS],
    path: Location.RISK_NOTIFICATIONS,
    component: RiskNotificationsPage,
    featureFlag: 'knockInApp',
  },
];

export default routes;
